/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { InquiryResponseDto } from './inquiryResponseDto';
import type { ListingResponseDto } from './listingResponseDto';
import type { TopAdvertItemResponseDtoType } from './topAdvertItemResponseDtoType';

export interface TopAdvertItemResponseDto {
  type: TopAdvertItemResponseDtoType;
  /** @nullable */
  listing: ListingResponseDto | null;
  /** @nullable */
  inquiry: InquiryResponseDto | null;
}
